export const checkboxTheme = {
  font: '--medkit-font',
  background: '--medkit-checkbox-primary',
  backgroundHover: '--medkit-checkbox-primary-light',
  backgroundDisabled: '--medkit-checkbox-disabled',
}
